import { Routes, Route } from "react-router-dom";
import App from "./App";
import Admin from "./Admin";
import MemberPage from "./MemberPage";
import MemberLogin from "./MemberLogin"; // ✅ ADD
import MemberPortal from "./MemberPortal"
import { ProtectedAdminRoute, ProtectedMemberRoute, ProtectedSuperAdminRoute} from "./ProtectedRoutes";
import Settings from "./Settings";

function AppRouter() {
  return (
    <Routes>
      <Route path="/*" element={<App />} />
      <Route
  path="/admin"
  element={
    <ProtectedAdminRoute>
      <Admin />
    </ProtectedAdminRoute>
  }
/>

 

<Route
  path="/settings"
  element={ <ProtectedSuperAdminRoute>
  <Settings />
</ProtectedSuperAdminRoute>
  }
/>


      <Route path="/member/:id" element={

        <ProtectedAdminRoute>
        <MemberPage />
        </ProtectedAdminRoute>
        
        }
         />

      {/* 🔐 MEMBER ROUTES */}
      <Route path="/login" element={<MemberLogin />} />
      <Route path="/member-portal" element={
        
         <ProtectedMemberRoute>
        <MemberPortal />
        
        </ProtectedMemberRoute>
        
        } />
    </Routes>
  );
}

export default AppRouter;